export const IconNames = {
  None: '',
  Edit: 'edit',
  Search: 'search',
  Restart: 'restart',
  Add: 'add',
  Subtract: 'subtract',
  Close: 'close',
  Fire: 'fire',
  ExclamationMark: 'exclamation-mark',
  Happy: 'happy',
  ChevronDown: 'chevron-down',
  ChevronUp: 'chevron-up',
  ChevronUpDown: 'chevron-up-down',
  ChevronDoubleDown: 'chevron-double-down',
  ChevronLeft: 'chevron-left',
  ChevronRight: 'chevron-right',
  ArrowUp: 'arrow-up',
  ArrowDown: 'arrow-down',
  ArrowLeft: 'arrow-left',
  ArrowRight: 'arrow-right',
  Sunglasses: 'sunglasses',
  Sun: 'sun',
  Info: 'info',
  Earth: 'earth',
  Purchase: 'purchase',
  Currency: 'currency',
  Maximize: 'maximize',
  Locked: 'locked',
  Information: 'information',
  InformationFilled: 'information-filled',
  Menu: 'menu',
  Menu4: 'menu-4',
  MenuDots: 'menu-dots',
  PendingFilled: 'pending-filled',
  Checkmark: 'checkmark',
  CheckmarkOutline: 'checkmark-outline',
  CheckmarkFilled: 'checkmark-filled',
  Chart3D: 'chart-3D',
  Notification: 'notification',
  Home: 'home',
  Money: 'money',
  ChartHistogram: 'chart-histogram',
  Folder: 'folder',
  SettingsAdjust: 'settings-adjust',
  DnsService: 'dns-service',
  Store: 'store',
  Gift: 'gift',
  Timer: 'timer',
  Building: 'building',
  User: 'user',
  Help: 'help',
  Warning: 'warning',
  WarningFilled: 'warning-filled',
  WarningAlt: 'warning-alt',
  Error: 'error',
  Bar: 'bar',
  Qr: 'qr',
  Wallet: 'wallet',
  Enterprise: 'enterprise',
  StatusAcknowledge: 'status-acknowledge',
  Identification: 'identification',
  UserProfile: 'user-profile',
  DataCheck: 'data-check',
  Hubspot: 'hubspot',
  StudySkip: 'study-skip',
  UserFollow: 'user-follow',
  FlowConnect: 'flow-connect',
  ShoppingCard: 'shopping-card',
  DataViewAlt: 'data-view-alt',
  AppleStore: 'apple-store',
  PlayStore: 'play-store',
  Plug: 'plug',
  UserAvatar: 'user-avatar',
  ShoppingCardArrowDown: 'shopping-card-arrow-down',
  RecordingFilled: 'recording-filled',
  Recording: 'recording',
  Copy: 'copy',
  Upload: 'upload',
  Document: 'document',
  Download: 'download',
  Friendship: 'friendship',
  Send: 'send',
  Filter: 'filter',
  ViewOff: 'viewoff',
  TrashCan: 'trashcan',
  Bookmark: 'bookmark',
  PlayFilled: 'play-filled',
  DocumentPdf: 'document-pdf',
  Terminal: 'terminal',
  Code: 'code',
  Horn: 'horn',
  Chemistry: 'chemistry',
  Book: 'book',
  Image: 'image',
  Person: 'person',
  Facebook: 'facebook',
  YouTube: 'you-tube',
  LinkedIn: 'linked-in',
  WhitePaper: 'white-paper',
  MobileCheck: 'mobile-check',
  Sms: 'sms',
  Headset: 'headset',
  Product: 'product',
  Receipt: 'receipt',
  Activity: 'activity',
  ArrowsVertical: 'arrows-vertical',
  ViewOffFilled: 'view-off-filled',
  ViewFilled: 'view-filled',
  CopyFile: 'copy-file',
  Calendar: 'calendar',
  Save: 'save',
  Scope: 'scope',
} as const;
export type ObjectValues<T> = T[keyof T];
export type IconNamesType = ObjectValues<typeof IconNames>;
